const $ = require('jQuery');

// Functions / components
function whitepaper_sections($this) {
    // Get all section_title components with data-anchor=true
    const $titles_for_contents = $('[data-component="section_title"][data-anchor="true"]');
    const $table_of_contents = $($this).find('.sections-contents-links');
    const $all_sections = $($this).find('.sections-main > div');

    // Create a list of links to each section
    $titles_for_contents.each(function () {
        const $title = $(this);
        const section_id = $title.attr('id');
        const section_title = $title.find('h3').text();
        const section_gated = $title.data('gated');

        const $section_link = $('<a>', {
            style: 'font-size: 14px; line-height: 20px; margin-bottom: 20px; font-weight: 400;',
            href: '#' + (section_gated ? 'whitepaper-form' : section_id),
            text: section_title,
            class: 'sections-contents-link' + (section_gated ? ' sections-contents-link--gated' : ''),
            "data-href": (section_gated ? '#' + section_id : '')
        });

        // Add the link to the table of contents
        $table_of_contents.append($section_link);
    });
    
    let section_gated = false;
    let section_parent = '';
    $all_sections.each(function () {
        const $section = $(this);

        if($section.data('component') === 'section_title' && $section.data('gated')) {
            section_gated = true;
            section_parent = $section.attr('id');
        } else if($section.data('component') === 'section_title') {
            section_gated = false;
            section_parent = '';
        }

        if(section_gated) {
            $section.addClass('section-gated');
            $section.attr('data-parent', section_parent);
        }
    });
}

// Router
$(function() {
    $('[data-component="sections"]').each(function () {
        whitepaper_sections(this);
    });
})